import request from '../../src/state/modules/axios'

export function getEducation(){
    return request({
        url: '/api/educations',
        method: 'get',
    })
}

export function getEducationById(data){
    return request({
        url: `/api/educations/${data.id}`,
        method: 'get',
    })
}

export function addEducation(data){
    return request({
        url: '/api/educations',
        method: 'post',
        data,
    })
}

export function editEducation(data){
    return request({
        url: `/api/educations/${data.id}`,
        method: 'put',
        data,
    })
}

export function deleteEducation(data){
    return request({
        url: `/api/educations/${data.id}`,
        method: 'delete'
    })
}